import { gql } from '@apollo/client';

export const common = gql`
  query {
    isMobile @client
    user @client
    isShell @client
    source @client
    isWebview @client
  }
`;

/**
 * Function that return a query based on token key
 * @param {String} TOKEN_KEY
 */
export const getTokens = TOKEN_KEY => gql`
 query getTokens @client {
   tokens @client {
     ${TOKEN_KEY} {
       action
       type
     }
   }
 }
`;

export const citySuggest = gql`
  query GetCities($payload: CitySuggestInput!) {
    citysuggest(input: $payload) {
      id
      name
    }
  }
`;
